module.exports = __webpack_public_path__ + "img/99fa7a1a7c0a83e35f3b237839e1ebed.99fa7a1a.png";